<script lang="ts">
    import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
    import { createRender, createTable, Render, Subscribe } from "svelte-headless-table";
    import { addPagination, addTableFilter } from "svelte-headless-table/plugins";
    import { readable } from "svelte/store";
    import * as Table from "$lib/components/ui/table";
    import { getContext, onMount } from "svelte";
    import { ContextTokens } from "../contexts/ContextTokens";
    import GsAction from "./gs-action.svelte";
    import { Input } from "$lib/components/ui/input";
    import * as Pagination from "$lib/components/ui/pagination";
    import { t } from 'svelte-i18n'
    import GsNavigation from "./gs-navigation.svelte";

    let { groupStoresAccess }  : AuthContext = getContext(ContextTokens.Auth);

    const table = createTable(readable($groupStoresAccess?.groupStores), {
      page: addPagination({initialPageSize:8}),
      filter: addTableFilter({
        fn: ({ filterValue, value }) =>
          value.toLowerCase().includes(filterValue.toLowerCase()),
      }),
    });

    const columns = table.createColumns([
        table.column({
            accessor: "groupStoreName",
            header: $t('groupstores.columns.name'),
        }),
        table.column({
            accessor: ({ groupStoreId }) => groupStoreId,
            header: "",
            cell: ({ value }) => {
              return createRender(GsAction, { id: value });
            },
        }),
    ]);

    const tableModel = table.createViewModel(columns);
    const { headerRows, pageRows, tableAttrs, tableBodyAttrs, pluginStates } = tableModel;
    const { pageIndex,  pageSize } = pluginStates.page;
    const { filterValue, preFilteredRows } = pluginStates.filter;
     
    let inputRef : Input;

    onMount(() => {
      inputRef.focus();
    })

</script>


<div class="flex items-center py-4">
  <Input
    bind:this={inputRef}
    class="max-w-sm"
    placeholder={$t('page.groupstores.search') + '...'}
    type="text"
    bind:value={$filterValue}
  />
</div>

  <div class="rounded-md border">
    <Table.Root {...$tableAttrs}>
      <Table.Header>
        {#each $headerRows as headerRow}
          <Subscribe rowAttrs={headerRow.attrs()}>
            <Table.Row>
              {#each headerRow.cells as cell (cell.id)}
                <Subscribe attrs={cell.attrs()} let:attrs props={cell.props()}>
                  <Table.Head {...attrs}>
                    <Render of={cell.render()} />
                  </Table.Head>
                </Subscribe>
              {/each}
            </Table.Row>
          </Subscribe>
        {/each}
      </Table.Header>
      <Table.Body {...$tableBodyAttrs}>
        {#if $pageRows.length}
          {#each $pageRows as row (row.id)}
            <Subscribe rowAttrs={row.attrs()} let:rowAttrs>
              <Table.Row {...rowAttrs}>
                {#each row.cells as cell (cell.id)}
                  <Subscribe attrs={cell.attrs()} let:attrs>
                    <Table.Cell {...attrs}>
                      {#if cell.id !== "groupStoreName"}
                        <div class="text-right">
                          <Render of={cell.render()} />
                        </div>
                      {:else}
                        <Render of={cell.render()} />
                      {/if}
                    </Table.Cell>
                  </Subscribe>
                {/each}
              </Table.Row>
            </Subscribe>
          {/each}
          {:else}
        <Table.Row>
						<Table.Cell colspan={columns.length} class="h-24 text-center">
							{$t('global.messages.noresult')}
						</Table.Cell>
					</Table.Row>
				{/if}
      </Table.Body>
    </Table.Root>
  </div>

  <GsNavigation {tableModel} />
